export default function BackendInstaller() {

  const downloadInstaller = () => {
    window.location.href =
       "https://companion-frontend-ten.vercel.app/downloads/Installer.exe";//production
     
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="bg-white p-10 rounded-xl shadow-xl text-center max-w-md">

        <div className="text-5xl mb-4">⚠️</div>

        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Backend Not Installed
        </h2>

        <p className="text-slate-500 mb-6">
          ShortcutsPOS Companion is required to connect to your local database.
        </p>

        <button
          onClick={downloadInstaller}
          className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-lg shadow hover:scale-105 transition"
        >
          Download Companion Installer
        </button>

      </div>
    </div>
  );
}